import { render, staticRenderFns } from "./PDFDocumentAdv.vue?vue&type=template&id=0f35fd28&"
import script from "./PDFDocumentAdv.vue?vue&type=script&lang=js&"
export * from "./PDFDocumentAdv.vue?vue&type=script&lang=js&"
import style0 from "./PDFDocumentAdv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports